class MultiColumnFeaturesCarousel {
  constructor(element) {
    this.section = element;
    this.splideElement = this.section.querySelector('#features-carousel');
    this.progressFill = this.section.querySelector('#progress-fill');
    this.splide = null;
    this.isEnabled = this.section.dataset.enableCarousel === 'true';
    this.totalProducts = 0;
    this.productsPerSlide = 1;

    if (this.isEnabled && this.splideElement) {
      this.init();
    }
  }

  init() {
    if (typeof Splide === 'undefined') {
      setTimeout(() => this.init(), 100);
      return;
    }

    this.initSplide();
    this.bindEvents();
  }

  initSplide() {
    this.totalProducts = this.getTotalProducts();
    this.productsPerSlide = this.getProductsPerSlide();
    
    this.splide = new Splide(this.splideElement, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '1rem',
      arrows: false,
      pagination: false,
      drag: true,
      snap: true,
      flickPower: 300,
      flickMaxPages: 1,
      speed: 600,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
      autoWidth: false,
      focus: 'center',
      trimSpace: false,
      rewind: true,
      breakpoints: {
        768: {
          drag: true,
          snap: true,
        }
      }
    });
    this.splide.mount();
    this.splide.on('moved', (newIndex) => {
      this.updateProgress(newIndex);
    });
    this.updateProgress(0);
  }

  getTotalProducts() {
    let total = parseInt(this.splideElement.dataset.totalProducts);
    
    if (!total || total === 0) {
      const slides = this.splideElement.querySelectorAll('.splide__slide');
      total = slides.length;
      
      if (!total || total === 0) {
        const featureItems = this.section.querySelectorAll('.multicolumn__item, .feature-item, .column-item');
        total = featureItems.length;
      }
    }
    
    return total || 2; 
  }

  getProductsPerSlide() {
    let perSlide = parseInt(this.splideElement.dataset.productsPerSlide);
    
    if (!perSlide || perSlide === 0) {
      const firstSlide = this.splideElement.querySelector('.splide__slide');
      if (firstSlide) {
        const itemsInSlide = firstSlide.querySelectorAll('.multicolumn__item, .feature-item, .column-item').length;
        perSlide = itemsInSlide || 1;
      } else {
        perSlide = 1;
      }
    }
    
    return perSlide;
  }

  bindEvents() {
    if (!('ontouchstart' in window)) {
      this.splideElement.addEventListener('mouseenter', () => {
      });

      this.splideElement.addEventListener('mouseleave', () => {
      });
    }
    if (!('ontouchstart' in window)) {
      document.addEventListener('keydown', (e) => {
        if (this.isInViewport()) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.splide.go('<');
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.splide.go('>');
          }
        }
      });
    }
  }

  updateProgress(currentIndex) {
    if (!this.progressFill || !this.splide) {
      return;
    }
    const totalSlides = this.splide.Components.Controller.getEnd() + 1;
    const progressPercentage = totalSlides > 1 ? ((currentIndex + 1) / totalSlides) * 100 : 100;
    
    this.progressFill.style.width = `${Math.min(progressPercentage, 100)}%`;
    this.progressFill.style.transition = 'width 0.3s ease';
  }

  isInViewport() {
    const rect = this.section.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  destroy() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
function initializeCarousels() {
  if (typeof Splide === 'undefined') {
    setTimeout(initializeCarousels, 100);
    return;
  }

  const carouselSections = document.querySelectorAll('.multicolumn-features');
  
  carouselSections.forEach(section => {
    if (!section.carouselInstance) {
      section.carouselInstance = new MultiColumnFeaturesCarousel(section);
    }
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCarousels);
} else {
  initializeCarousels();
}
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.multicolumn-features')) {
    const section = event.target.querySelector('.multicolumn-features');
    if (section.carouselInstance) {
      section.carouselInstance.destroy();
    }
    setTimeout(() => {
      section.carouselInstance = new MultiColumnFeaturesCarousel(section);
    }, 100);
  }
});
document.addEventListener('shopify:section:unload', function(event) {
  if (event.target.querySelector('.multicolumn-features')) {
    const section = event.target.querySelector('.multicolumn-features');
    if (section.carouselInstance) {
      section.carouselInstance.destroy();
      section.carouselInstance = null;
    }
  }
});
let resizeTimeout;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function() {
    const carouselSections = document.querySelectorAll('.multicolumn-features');
    carouselSections.forEach(section => {
      if (section.carouselInstance && section.carouselInstance.splide) {
        section.carouselInstance.splide.refresh();
      }
    });
  }, 250);
});